if(typeof ele === 'undefined'){
    ele = {}
}

(function(){
    //TODO overcomplicated solution to a simple task. Rewrite

    /* ------------------------------------ */
    /* ----- Notify - Publisher class ----- */
    /* ------------------------------------ */
    /*
     * Takes functions as subscribers, when triggered
     * Launches all functions subscribing to the notifier.
     * Passes on any arguments:
     *
     * To create a notifier:
     * notifier=new ele.notifier();
     *
     * To subscribe:
     * notifier.subscribe(fn); // Where fn is the function to execute on notification
     *
     * To unsubscribe:
     * notifier.unsubscribe(fn); // Where fn is the function to remove from the list of functions to execute on notification
     *
     * To publish
     * notifier(argument1,argument2...argumentn); // arguments are the list of arguments to pass to the functions being executed
     */
    ele.notifier = function(){
        var l=[];
        var r=function(){
            // Loop through function array, execute and pass on any arguments this function may have been passed
            for(var i=0;i<l.length;i++){
                l[i].apply(this,arguments);
            }
        };
        // Adds a function to the function array
        r.subscribe=function(fn){
            if(typeof(fn)=='function'){
                l.push(fn);
            }
            // Return this to allow method chaining
            return this;
        };
        // Removes a function from the function array
        r.unsubscribe=function(fn){
            var a=[];
            // Loop through function array, compare functions create a new array of functions
            for(var i=0;i<l.length;i++){
                if(l[i]!=fn){
                    a.push(l[i]);
                }
            }
            // Replace current array with new one
            l=a;
            // Return this to allow method chaining
            return this;
        };
        return r;
    };
    /* -------------------------------------- */
    /* ----- Calculator - Utility class ----- */
    /* -------------------------------------- */
    /*
     * Creates a calculator that uses a custom algorithm
     * to calculate a result. Has notification events for
     * result and error:
     *
     * To create a calculator:
     * calculator=new ele.calculator(fn); // Where fn is the custom algorithm function that takes a number and returns the calculated number, or returns a string as an error message
     *
     * To use a calculator:
     * r=calculator.calculate(n); // Where n is the input number, r will equal the result calculation
     *
     * To subscribe to calculator events:
     * calculator.subscribe('result',fn); // fn is the function to execute when the calculator is used and returns a result
     * calculator.subscribe('error',fn); // fn is the function to execute when the calculator is used and returns an error
     */
    ele.calculator = function(fn){
        // Event notifiers
        var notify={
            error:new ele.notifier(),
            result:new ele.notifier()
        };
        return{
            calculate:function(n){
                // Make sure value passed is converted to a number
                n=n*1;
                if(typeof(n)=='number'&&!isNaN(n)){
                    var r=fn(n);
                    // Calculation returned a result, notify result listeners
                    if(typeof(r)=='number'){
                        notify.result(r);
                        // Calculation returned an error, notify error listeners
                    }else if(typeof(r)=='string'){
                        notify.error(r);
                    }
                    return r;
                    // If value passed cannot be converted to a number
                }else{
                    notify.error('Please enter a number');
                    return false;
                }
            },
            // Subscribe to event notifiers
            subscribe:function(event,fn){
                if(typeof(notify[event])!='undefined'){
                    notify[event].subscribe(fn);
                }
                return this;
            },
            // Unsubscribe to event notifiers
            unsubscribe:function(event,fn){
                if(typeof(notify[event])!='undefined'){
                    notify[event].unsubscribe(fn);
                }
                return this;
            }
        };
    };

})();